import { FC, useState } from 'react';
import { useEnhancedTranslation } from '@app/hooks';
import './personal-account-valid-card.scss';
import { formatNumberWithSpaces } from '@app/utils';
import { NewButton } from '@app/components/NewButton/NewButton';
import { NewButtonIcon } from '@app/components/NewButton/NewButtonIcon';
import PersonalAccountCongratulations from '../PersonalAccountCongratulations/PersonalAccountCongratulations';
import PersonalAccountQRModal from '../PersonalAccountQRModal/PersonalAccountQRModal';

type TProps = {
  date: string;
  image: string;
  nominal: number;
  remains: number;
  cardNumber: string;
  giftMessage?: {
    message: string;
    recipientName: string;
    senderName: string;
  };
  title: string;
};

const PersonalAccountValidCard: FC<TProps> = ({ date, image, nominal, remains, giftMessage, cardNumber, title }) => {
  const { t } = useEnhancedTranslation({ keyPrefix: 'account.personalAccount.validCards' });
  const [isCongratulationsVisible, setIsCongratulationsVisible] = useState(false);
  const [isQRVisible, setIsQRVisible] = useState(false);
  function congratulationsModalOpen(): void {
    document.querySelector('body')?.classList.add('fixed');
    setIsCongratulationsVisible(true);
  }
  function congratulationsModalClose(): void {
    document.querySelector('body')?.classList.remove('fixed');
    setIsCongratulationsVisible(false);
  }
  function QRModalOpen(): void {
    document.querySelector('body')?.classList.add('fixed');
    setIsQRVisible(true);
  }
  function QRModalClose(): void {
    document.querySelector('body')?.classList.remove('fixed');
    setIsQRVisible(false);
  }
  return (
    <div className="personal-account-valid-card">
      <div className="personal-account-valid-card__image">
        <img src={image} alt="" />
      </div>
      <div className="personal-account-valid-card__main-wrap">
        <div className="personal-account-valid-card__title-wrap">
          <div className="personal-account-valid-card__title">{title}</div>
          <div className="personal-account-valid-card__date">
            {t('before')} {date}
          </div>
        </div>
        <div className="personal-account-valid-card__bottom-wrap">
          <div className="personal-account-valid-card__left-block">
            <div className="personal-account-valid-card__left-title">{t('left')}</div>
            <div className="personal-account-valid-card__count-wrap">
              <div className="personal-account-valid-card__remains">{formatNumberWithSpaces(remains.toString())} ₽</div>
              <div className="personal-account-valid-card__nominal">
                {t('of')} {formatNumberWithSpaces(nominal.toString())} ₽
              </div>
            </div>
          </div>
          <div className="personal-account-valid-card__btn-wrap">
            {giftMessage && (
              <NewButton
                size="small"
                variant="white"
                addClass="personal-account-valid-card__btn"
                onClick={() => congratulationsModalOpen()}
              >
                {t('congratulation')}
              </NewButton>
            )}
            <NewButtonIcon
              onClick={() => QRModalOpen()}
              size="small"
              addClass="personal-account-valid-card__icon-btn"
              icon={
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M3 11V3H11V11H3ZM5 9H9V5H5V9ZM3 21V13H11V21H3ZM5 19H9V15H5V19ZM13 11V3H21V11H13ZM15 9H19V5H15V9ZM19 21V19H21V21H19ZM13 15V13H15V15H13ZM15 17V15H17V17H15ZM13 19V17H15V19H13ZM15 21V19H17V21H15ZM17 19V17H19V19H17ZM17 15V13H19V15H17ZM19 17V15H21V17H19Z"
                    fill="white"
                  />
                </svg>
              }
            />
          </div>
        </div>
      </div>
      {isCongratulationsVisible && (
        <PersonalAccountCongratulations
          giftMessage={giftMessage}
          nominal={nominal}
          image={image}
          onClose={() => congratulationsModalClose()}
        />
      )}
      {isQRVisible && <PersonalAccountQRModal number={cardNumber} onClose={() => QRModalClose()} />}
    </div>
  );
};

export default PersonalAccountValidCard;
